module.exports = __webpack_public_path__ + "static/media/icon-devolucao-erro.b09b636c.svg";